var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSearchTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "90px",
    height: "75.22px",
    viewBox: "0 0 90 75.22",
    style: {
      enableBackground: "new 0 0 90 75.22"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:none;stroke:#1C4EC1;stroke-width:2;}\r\n\t.st2{fill:#1C4EC1;}\r\n\t.st3{fill:#1C4EC1;stroke:#1C4EC1;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_272",
    transform: "translate(-277 -628)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico_relation_prof",
    transform: "translate(277 628)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6955\\u5186\\u5F62_32",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 37.61,
    cy: 37.61,
    r: 37.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 37.61,
    cy: 37.61,
    r: 36.61
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_201",
    className: "st2",
    d: "M44.08,45.7h3.24v-3.24h-3.24V45.7z M44.08,39.23h3.24v-3.24h-3.24V39.23z M24.67,45.7h3.24 v3.24h-3.24V45.7z M31.14,45.7h3.24v3.24h-3.24V45.7z M24.67,39.23h3.24v3.24h-3.24V39.23z M31.14,39.23h3.24v3.24h-3.24V39.23z  M24.67,32.76h3.24v3.24h-3.24V32.76z M31.14,32.76h3.24v3.24h-3.24V32.76z M37.61,32.76h12.94v16.18H37.61V45.7h3.24v-3.24h-3.24 v-3.24h3.24v-3.24h-3.24V32.76z M24.67,26.28h3.24v3.24h-3.24V26.28z M31.14,26.28h3.24v3.24h-3.24V26.28z M21.43,23.05v29.12 h32.36V29.52H37.61v-6.47H21.43z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u6955\\u5186\\u5F62_4",
    transform: "translate(330.731 628)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 18.13,
    cy: 18.13,
    r: 18.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 18.13,
    cy: 18.13,
    r: 17.13
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_15",
    className: "st3",
    d: "M356.38,655.2l-6.23-6.23c-0.51,0.41-1.09,0.72-1.71,0.94c-0.66,0.23-1.35,0.35-2.05,0.35 c-1.71,0.03-3.36-0.64-4.56-1.86c-1.22-1.2-1.9-2.85-1.86-4.56c-0.03-1.71,0.64-3.36,1.86-4.56c1.2-1.22,2.85-1.9,4.56-1.86 c1.71-0.03,3.36,0.64,4.56,1.86c1.22,1.2,1.9,2.85,1.86,4.56c0,0.7-0.11,1.39-0.35,2.05c-0.22,0.62-0.53,1.19-0.94,1.71l6.23,6.23 L356.38,655.2z M346.39,648.28c1.19,0.02,2.33-0.45,3.15-1.3c0.85-0.83,1.32-1.97,1.3-3.15c0.02-1.18-0.45-2.33-1.3-3.15 c-0.83-0.85-1.97-1.32-3.15-1.3c-1.19-0.02-2.33,0.45-3.16,1.3c-0.85,0.83-1.32,1.97-1.29,3.16c-0.02,1.18,0.45,2.32,1.29,3.15 C344.07,647.83,345.21,648.3,346.39,648.28"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSearchTitle);
export default __webpack_public_path__ + "static/media/ico_search_title.1fde0e452d0364ede50040058ce9f422.svg";
export { ForwardRef as ReactComponent };